import _ from 'lodash';
import React, { Component } from 'react';
import classnames from 'classnames';
import Nav from '../../components/nav/Nav';
import Footer from '../../components/footer/Footer';
import BaseMeta from '../../components/base-meta/BaseMeta';
import Loading from '../../components/loading-v2/LoadingV2';
import BlogLogo from '../../components/blog-logo/BlogLogo';
import BlogFeaturedPost from '../../components/blog-featured-post/BlogFeaturedPost';
import BlogPostItem from '../../components/blog-post-item/BlogPostItem';
import InstagramItems from '../../components/instagram-items/InstagramItems';
import { fetchAll } from '../../stores/BlogPostStore';
import endPoints from '../../utils/endPoints';
import styles from './Blog.css';

const AxiosUtils = require('../../utils/axios');

class Blog extends Component {
  componentDidMount() {
    fetchAll().then(posts => {
      const featuredPost = posts.find(p => p.isFeatured);
      this.setState({ posts, featuredPost });
    });

    AxiosUtils.initAxios()
      .get(endPoints.JOURNALS())
      .then((response) => {
        const { records } = response.data;
        const instagrams = records.map(record => {
          return {
            createdAt: new Date(parseInt(record.fields.createdAt, 10) * 1000).toISOString(),
            link: record.fields.link,
            picUrl: record.fields.picUrl,
            videoUrl: record.fields.videoUrl,
            caption: record.fields.caption,
          }
        });
        // get first 10 records
        this.setState({ instagrams: instagrams.slice(0, 12) });
      })
      .catch((error) => {
        console.log(error.response);
        throw error;
      });
  }

  state = {
    featuredPost: null,
    posts: [],
    instagrams: [],
    loadingAnimDone: false,
  };

  renderInstagrams() {
    const { instagrams } = this.state;

    return (
      <div className={styles.instagrams}>
        {instagrams.length !== 0 && [
          <p
            className={styles.instagramsLabel}
            key="instagram-label"
          >
            Instagram
          </p>,
          <InstagramItems instagrams={instagrams} key="instagram-items" />,
        ]}
      </div>
    );
  }

  render() {
    const { posts, featuredPost } = this.state;

    if (posts.length === 0 && featuredPost === null) {
      return (
        <BaseMeta path={this.props.location.pathname} title="Blog">
          <Loading />
        </BaseMeta>
      );
    }

    if (!this.state.loadingAnimDone) {
      setTimeout(() => this.setState({ loadingAnimDone: true }), 500);
      return (
        <BaseMeta path={this.props.location.pathname} title="Blog">
          <Loading hide />
        </BaseMeta>
      );
    }

    const postRows = [];
    _.forEach(posts, post => {
      const last = _.last(postRows);
      if (!last || last.length === 3) {
        postRows.push([post]);
      } else {
        last.push(post);
      }
    });

    return (
      <main className={'animated fadeIn'}>
        <BaseMeta path={this.props.location.pathname} title="Blog" />
        <Nav activeItem="blog" />
        <section className="container">
          <BlogLogo />

          <BlogFeaturedPost post={featuredPost} />

          <div className={styles.blogPostRows}>
            {postRows.map((row, idx) => (
              <div
                className={classnames(styles.blogPostRow, 'row')}
                key={`row-${idx}`}
              >
                {row.map((post, idx) => (
                  <BlogPostItem post={post} key={`blog-${idx}`} />
                ))}
              </div>
            ))}
          </div>
          {this.renderInstagrams()}
        </section>
        <Footer />
      </main>
    );
  }
}

export default Blog;



// WEBPACK FOOTER //
// ./src/containers/blog/Blog.js